import React from 'react';
import './NotificationModal.css';

const NotificationModal = ({ message, onClose, isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="notification-modal-overlay">
      <div className="notification-modal">
        <div className="notification-header">SUCCESS</div>
        <div className="notification-content">
          <pre className="notification-message">{message}</pre>
        </div>
        <div className="notification-actions">
          <button
            className="notification-button"
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;